export class PersistService {
    static setModel(fb, model) {
        localStorage.setItem('model', JSON.stringify(model));
        if (fb.auth().currentUser) {
            fb.database().ref('users/' + fb.auth().currentUser.uid).set(JSON.stringify(model));
        }
    }
    static async getModel(fb) {
        let model;
        let parsedModel;
        if (fb.auth().currentUser) {
            model = await new Promise((res, rej) => {
                fb.database().ref('users/' + fb.auth().currentUser.uid).once('value', value => {
                    res(value.val());
                });
            })
        } else {
            model = localStorage.getItem('model');
        }
        try {
            parsedModel = JSON.parse(model);
        } catch (e) {
            console.error(e);
        }
        if (parsedModel) {
            return parsedModel;
        } else {
            return [];
        }
    }
}


// WEBPACK FOOTER //
// ./src/services/PersistService.js